import { DataWidgetFiltersInput, FilterInput } from 'dashboards/types/filter';

// Removes excess `id` fields only used in console.
export function sanitizeDataWidgetFilters(
  filters: DataWidgetFiltersInput[] | undefined
): FilterInput[] {
  if (!filters) {
    return [];
  }

  return filters.map(({ id, and, or, ...rest }) => ({
    ...rest,
    and: and ? sanitizeDataWidgetFilters(and) : undefined,
    or: or ? sanitizeDataWidgetFilters(or) : undefined,
  }));
}
